export default "assets/om-logistics-logo.svg"